import styles from "./SettingsSectionPage.module.css";

interface SettingsSectionPageProps {
  title: string;
  description: string;
}

export const SettingsSectionPage = ({ title, description }: SettingsSectionPageProps) => {
  return (
    <div className={styles.card}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
    </div>
  );
};
